import { SystemIcon, Typography, Box } from '@wishket/design-system';

import { twJoin } from 'tailwind-merge';

const TitleChip = () => {
  return (
    <Box
      className={twJoin(
        'absolute left-0 top-0 h-[52px] w-[144px] rounded-br-[24px] bg-w-white'
      )}
    >
      <Box
        className={twJoin(
          'relative h-full w-full',
          'before:absolute before:-bottom-[30px] before:-left-[2px] before:h-[32px] before:w-[32px] before:bg-radius-transparent-24px',
          'after:absolute after:-right-[30px] after:-top-[2px] after:h-[32px] after:w-[32px] after:bg-radius-transparent-24px'
        )}
      >
        <Box
          className={twJoin(
            'flex h-9 w-[128px] items-center justify-center gap-2 rounded-[32px] bg-primary px-3 py-[5px]'
          )}
        >
          <SystemIcon name="medium_fire" className="text-w-white" solid />
          <Typography
            variant="body1"
            className="select-none font-medium text-w-white"
          >
            오늘의 토픽
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TitleChip;
